import { Bar, CartesianGrid, ComposedChart, Legend, Line, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { gbp, gbpShort } from "../lib/format";

const c = (v) => `hsl(var(${v}))`;

function Tip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-md border bg-popover px-3 py-2 text-xs shadow-lg">
      <div className="mb-1 font-heading font-bold">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex justify-between gap-6">
          <span style={{ color: p.color }}>{p.name}</span><span className="font-figure">{gbp(p.value)}</span>
        </div>
      ))}
    </div>
  );
}

export function CashChart({ data }) {
  return (
    <div className="h-[320px] w-full min-w-0" data-testid="quarterly-cash-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={0}>
        <ComposedChart data={data} margin={{ top: 10, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="quarter" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} tickLine={false} axisLine={false} interval="preserveStartEnd" minTickGap={18} />
          <YAxis tickFormatter={gbpShort} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} tickLine={false} axisLine={false} width={64} />
          <Tooltip content={<Tip />} cursor={{ fill: "hsl(var(--muted))" }} />
          <Legend wrapperStyle={{ fontSize: 12, color: "hsl(var(--foreground))" }} />
          <ReferenceLine y={0} stroke="hsl(var(--muted-foreground))" />
          <Bar dataKey="equity_out" name="Equity deployed" fill={c("--chart-out")} radius={[0, 0, 3, 3]} />
          <Bar dataKey="equity_back" name="Equity returned" fill={c("--chart-back")} stackId="in" />
          <Bar dataKey="profit" name="Profit" fill={c("--chart-profit")} stackId="in" radius={[3, 3, 0, 0]} />
          <Line dataKey="net" name="Net" stroke={c("--chart-net")} strokeWidth={2} dot={false} type="monotone" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
